<div class="displaycard" fxLayout="column" *ngIf="entity" fxLayoutGap="10px">
    <!-- triangle -->
    <div class="triangle">{{ entity.category.name }}</div>

    <!-- author -->
    <div fxLayout="row">
        <author [profile]="author" [created_at]="entity.created_at"> </author>
    </div>

    <div class="location">{{ entity.subtitle }}</div>

    <div fxLayout="column" fxLayoutGap="10px">
        <div class="content-wrapper" fxLayout="column" fxLayoutGap="10px">
            <div>
                <span class="title break-word">{{ entity.title }}</span>
            </div>
            <div>
                <span class="teaser break-word">{{ entity.teaser }}</span>
            </div>

            <!-- image gallery -->
            <app-swiper [galleryImages]="entity.galleryImages"></app-swiper>

            <!-- content -->
            <div [innerHTML]="entity.content" class="break-word"></div>
        </div>

        <!-- social icons -->
        <div fxLayout="row" fxLayout.lt-lg="column" *ngIf="live">
            <share-buttons
                fxFlex="30"
                [include]="
                    mobileService.isMobile
                        ? appConfig.shareconfig_mobile
                        : appConfig.shareconfig_desktop
                "
                [show]="appConfig.sharebuttonsmax"
                [url]="entity.getOpgraphData().url"
                [autoSetMeta]="false"
                description=" "
            ></share-buttons>

            <div
                fxLayout="row"
                fxLayoutAlign="end none"
                fxFlex.gt-md="70"
                fxLayoutGap.gt-md="20px"
                fxLayout.lt-lg="column"
            >
                <like-button *ngIf="entity" [likeable]="entity"></like-button>
            </div>
        </div>

        <!-- edit button -->
        <div
            *ngIf="
                live &&
                UserService.user &&
                entity.frontend_user_id == UserService.user.id
            "
        >
            <button
                fxLayout="row"
                fxLayoutGap="10px"
                fxLayoutAlign="start center"
                (click)="edit()"
            >
                <i class="far fa-edit"></i>
                <div>Anzeige Bearbeiten</div>
            </button>
        </div>
    </div>
</div>
